<template>
 <div class="modal-card"  >
     <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
 
   
    <header class="modal-card-head custom-modal-card-head" >
    <div  @keyup.enter="searchLABByID">
        <nav class="level level-scroll">
						<div class="level-left">
							<!-- <div class="level-item">
                                <b-button   type="is-danger is-light"
                                       icon-left="arrow-left" @click="close">
                                       Back
                                </b-button>  
							</div> -->

                            <div class="level-item">
                                    <b-field label="Lab Automate"
                                     :type="hasLABID_AutomateError ? 'is-danger' : ''  "
                                     :message="hasLABID_AutomateError ? 'This  is invalid' : ''  "
                                    >
                                        <template #label>
                                            <b-radio v-model="radioAutomateOrNonAutomate"
                                                @input = "inputRadio"
                                                native-value="0">
                                                Lab  Automate
                                            </b-radio>
                                        </template>
                                        <b-input :disabled="radioAutomateOrNonAutomate==1" 
                                          v-model="LABID_Automate"
                                          placeholder="67000111"
                                          @input="inputLABID_Automate"
                                          
                                         ></b-input>
                                    </b-field>
                            </div>

  
                            <div class="level-item">
                                    <b-field label="Lab Non Automate"
                                    
                                     :type="hasLABID_NonAutomateError ? 'is-danger' : ''  "
                                     :message="hasLABID_NonAutomateError ? 'This  is invalid' : ''  "
                                     
                                    
                                    >
                                        <template #label>
                                            <b-radio v-model="radioAutomateOrNonAutomate"
                                                @input = "inputRadio"
                                                native-value="1">
                                                Lab  Non Automate
                                            </b-radio>
                                        </template>
                                        <b-input :disabled="radioAutomateOrNonAutomate==0" 
                                        v-model="LABID_NonAutomate"  
                                        placeholder="67cyto10"
                                        @input="inputLABID_NonAutomate"
                                       
                                        ></b-input>
                                    </b-field>
                            </div>



                            <div class="level-item">
                                <b-button 
                                @click="searchLABByID"
                                class="mt-5 ml-5" 
                                icon-left="magnify"
                                :disabled="(hasLABID_AutomateError || hasLABID_NonAutomateError)"
                                >Search</b-button>   
                            </div>     
                             


                        </div>



                      


        </nav>    
    </div>

                          

     
    </header>
  





    <section class="modal-card-body" >
    <InfoOPD  :infoOPDObj="infoOPDObj" v-if="infoOPDObj" class="mb-5" />
 
    <!-- {{dataCBCSpecLN}} -->
      <!-- <div style="  text-align: center;">
        
        <h1 class="is-size-4 has-text-grey"
          v-if=" IDLABSelected.idlab" >
       
       
       <span class="is-size-5 has-text-grey">LAB No : </span>{{IDLABSelected.idlab}}
       
       
       </h1></div>  -->
<!-- {{dataCBCSpecLN['info']['idopd']}} -->
    <CBC_DetailEachID_V2   
        :dataCBCSpecLN="dataCBCSpecLN"
        :IDLABSelected="IDLABSelected"
        @trigRequestRefreshDataCBC="searchLABByID"
        v-if=" IDLABSelected && IDLABSelected.kind.toUpperCase()  === 'CBC'   " 
    />   


    <!-- {{dataPCRSpecLN}} -->
    <CYTOLOGY_EachID  :dataCytoSpecLN="dataCytoSpecLN"
                                  
                                  :IDLABSelected="IDLABSelected"
                                  @trigForPlusUpdate="trigForPlusUpdate"
                                  v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'CYTOLOGY' "/>
 
    <Biopsy_EachID  :dataBiopsySpecLN="dataBiopsySpecLN"
                   
                                :IDLABSelected="IDLABSelected"
                                @trigForPlusUpdate="trigForPlusUpdate"
                                v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'BIOPSY' " />


    <Orga_EachID   :dataORGASpecLN="dataORGASpecLN"
                               :IDLABSelected="IDLABSelected"
                               @trigForPlusUpdate="trigForPlusUpdate"
                               v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'ORGANISM' "/>


    <PARA_EachID   :dataPARASpecLN="dataPARASpecLN"
                               :IDLABSelected="IDLABSelected"
                                @trigForPlusUpdate="trigForPlusUpdate"
                                v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'PARASITE' "/>

    <Necropsy_EachID  :dataNecropsySpecLN="dataNecropsySpecLN"
                      @trigForPlusUpdate="trigForPlusUpdate"
                      :IDLABSelected="IDLABSelected"
                       v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'NECROPSY' " />

    <PCR_EachID
                     :dataPCRSpecLN="dataPCRSpecLN"
                     :IDLABSelected="IDLABSelected"
                     @trigForPlusUpdate="trigForPlusUpdate"
                     v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'PCR' " />

    <Bact_EachID    :dataBACTSpecLN="dataBACTSpecLN"
                    :IDLABSelected="IDLABSelected"
                    @trigForPlusUpdate="trigForPlusUpdate"
                    v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'BACTERIAL' "/>


    </section>

    <footer class="modal-card-foot" style="justify-content: space-between;" >
                         <b-button type="is-danger" 
                           icon-left="close-box" 
                          @click="close">Close</b-button> 


                                              
     </footer>
 





 




  </div>
</template>




<script>
import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios ,
             DATACYTOSPECLN_MODEL ,
             DATABIOPSPECLN_MODEL ,
             DATA_PCR_LN_MODEL,
             DATANECROPSPECLN_MODEL,
             DATA_BACT_LN_MODEL,
             DATA_PARA_LN_MODEL,
             DATA_ORGA_LN_MODEL,

}  from '@/utils.js'
import { mapState } from "vuex";   
import getDecodeFromBase64ToHtml from '../../mixins/methods/getDecodeFromBase64ToHtml'



import InfoOPD from './InfoOPD.vue'
import CBC_DetailEachID_V2 from "../../components/LABAutomate/CBC_DetailEachID_V2.vue";
import CYTOLOGY_EachID from "../LABNonAutomate/Cytology_EachID.vue";
import Biopsy_EachID from "../LABNonAutomate/Biopsy_EachID";
import Orga_EachID from "../LABNonAutomate/Orga_EachID"; 
import PARA_EachID from "../LABNonAutomate/PARA_EachID"; 
import Necropsy_EachID from "../LABNonAutomate/Necropsy_EachID.vue"; 
import PCR_EachID from "../LABNonAutomate/PCR_EachID.vue"; 
import Bact_EachID from "../LABNonAutomate/Bact_EachID"; 
 

export default {
    name : "SearchLabbyLabID",
    mixins:[getDecodeFromBase64ToHtml, ],
    components:{
        InfoOPD,
        CBC_DetailEachID_V2,
        CYTOLOGY_EachID,
        Biopsy_EachID,
        Orga_EachID,
        PARA_EachID,
        Necropsy_EachID,
        PCR_EachID,
        Bact_EachID,
    },
    props:{
        isComponentModalActive : Boolean,
    },
    computed:{
        ...mapState({
            access_token: state => state.master_data.access_token,
            user_id : state => state.master_data.user_id,
            clientIP : state => state.master_data.clientIP,
       
        }),

    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },  
    methods:{
 



        inputRadio(){
             this.hasLABID_AutomateError = false
             this.hasLABID_NonAutomateError = false
        },

        close(){
            this.$emit('close')
        },
        inputLABID_Automate(){
            this.LABID_NonAutomate = ""
            this.hasLABID_AutomateError = false
            this.hasLABID_NonAutomateError = false
        },
        inputLABID_NonAutomate(){
            this.LABID_Automate = "" 
            this.hasLABID_AutomateError = false
            this.hasLABID_NonAutomateError = false
        },
        isValidLABID_Automate(str)  {
            // Regular expression to match exactly 8 digits
            const regex = /^\d{8}$/;
            return regex.test(str);
        } ,

        isValidLABID_NonAutomate(str)  {
            // Regular expression to match exactly 8 digits
            
             //const regex = /^[a-zA-Z]+\d{0,4}\d$/;
             const regex = /^\d{2}[a-zA-Z]{3,4}\d+$/;
             
             return regex.test(str);
        } ,

        // Regular expression to match a pattern of up to 4 digits followed by a digit
        trigForPlusUpdate(){
            this.searchLABByID()
        },
        searchLABByID(){
            if(this.radioAutomateOrNonAutomate == 0) {
                if(!this.isValidLABID_Automate(this.LABID_Automate) ){
                    this.hasLABID_AutomateError = true
                    this.IDLABSelected = Object.assign({}, { "idlab": "", "kind": "" })
                    return
                }

               // not error -> next pass 
               this.isFullScreenLoading = true
                // init
                this.dataCBCSpecLN = null
                this.dataCytoSpecLN = DATACYTOSPECLN_MODEL
                this.dataBiopsySpecLN  =  DATABIOPSPECLN_MODEL
                this.dataPCRSpecLN = DATA_PCR_LN_MODEL
                this.dataBACTSpecLN = DATA_BACT_LN_MODEL
                this.dataPARASpecLN = DATA_PARA_LN_MODEL
                this.dataORGASpecLN = DATA_ORGA_LN_MODEL
                this.dataNecropsySpecLN = DATANECROPSPECLN_MODEL
                //
                this.infoOPDObj = null
                const datTo = {
                              "ln": this.LABID_Automate,
                              "user": this.user_id ,
                              "ip": this.clientIP
                            }
               
               
               axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
               axios.post(`${getBaseURLforBackEnd()}/api/labcbc_spec_opdno_spec_ln_v2`,datTo,getConfigAxios())
                    .then((res)=>{
                            this.dataCBCSpecLN = res.data
                            if(this.dataCBCSpecLN.info == null){
                              this.isFullScreenLoading = false
                              this.IDLABSelected = Object.assign({}, { "idlab": "", "kind": "" })
                              
                              this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `not found`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                             })

                            }else{
                               this.IDLABSelected = Object.assign({}, { "idlab": this.LABID_Automate, "kind": "CBC" })
                               this.dataCBCSpecLN['info'].comment_note =  this.dataCBCSpecLN['info'].comment_note ? this.getDecodeFromBase64ToHtml( this.dataCBCSpecLN['info'].comment_note )    :  this.dataCBCSpecLN['info'].comment_note  
                               this.dataCBCSpecLN['info'].tentative_dx =  this.dataCBCSpecLN['info'].tentative_dx ? this.getDecodeFromBase64ToHtml( this.dataCBCSpecLN['info'].tentative_dx )    :  this.dataCBCSpecLN['info'].tentative_dx  
                               this.dataCBCSpecLN['info'].diagnosis_note =  this.dataCBCSpecLN['info'].diagnosis_note ? this.getDecodeFromBase64ToHtml( this.dataCBCSpecLN['info'].diagnosis_note )    :  this.dataCBCSpecLN['info'].diagnosis_note  
                               this.dataCBCSpecLN['info'].result_remark =  this.dataCBCSpecLN['info'].result_remark ? this.getDecodeFromBase64ToHtml( this.dataCBCSpecLN['info'].result_remark )    :  this.dataCBCSpecLN['info'].result_remark  
                               
                               this.infoOPDObj    = Object.assign({}, 
                                                                    {
                                                                    idlab : this.dataCBCSpecLN.info.idlab,
                                                                    idopd : this.dataCBCSpecLN.info.idopd,
                                                                    opdname :  this.dataCBCSpecLN.info.name,
                                                                    type :  this.dataCBCSpecLN.info.breed,
                                                                    gender :  this.dataCBCSpecLN.info.sex,
                                                                    age :  this.dataCBCSpecLN.info.age,
                                                                    owner_name :  this.dataCBCSpecLN.info.owner_name
                                                                    }
                              )
                               
                               
                               this.isFullScreenLoading = false 
                            }

                            
                    })
                    .catch((err)=>{
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.isFullScreenLoading = false
              
                    })

                  

            }

            if(this.radioAutomateOrNonAutomate == 1) {
     
                 if(!this.isValidLABID_NonAutomate(this.LABID_NonAutomate)){
                    this.hasLABID_NonAutomateError = true
                    this.IDLABSelected = Object.assign({}, { "idlab": "", "kind": "" })
                    return
                 }

                // search_bylab_nonlisid
                // not error -> next pass 
                this.isFullScreenLoading = true
                // init
                this.dataCBCSpecLN = null
                this.dataCytoSpecLN = DATACYTOSPECLN_MODEL
                this.dataBiopsySpecLN  =  DATABIOPSPECLN_MODEL
                this.dataPCRSpecLN = DATA_PCR_LN_MODEL
                this.dataBACTSpecLN = DATA_BACT_LN_MODEL
                this.dataPARASpecLN = DATA_PARA_LN_MODEL
                this.dataORGASpecLN = DATA_ORGA_LN_MODEL
                this.dataNecropsySpecLN = DATANECROPSPECLN_MODEL
                // 
                this.infoOPDObj = null

                 
                const datTo =  { 
                                "ln" :  this.LABID_NonAutomate
                               }
               
               
               axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
               axios.post(`${getBaseURLforBackEnd()}/api/search_bylab_nonlisid`,datTo,getConfigAxios())
                    .then((res)=>{
                    // console.log(res.data)

                    //   console.log(res.data.lab_detail.status.id)
                       if(res.data.lab_detail.status.id<5){
                        // console.log("< 5 or 6")

                        this.dataCBCSpecLN = null
                        this.dataCytoSpecLN = DATACYTOSPECLN_MODEL
                        this.dataBiopsySpecLN  =  DATABIOPSPECLN_MODEL
                        this.dataPCRSpecLN = DATA_PCR_LN_MODEL
                        this.dataBACTSpecLN = DATA_BACT_LN_MODEL
                        this.dataPARASpecLN = DATA_PARA_LN_MODEL
                        this.dataORGASpecLN = DATA_ORGA_LN_MODEL
                        this.dataNecropsySpecLN = DATANECROPSPECLN_MODEL

                        this.IDLABSelected = Object.assign({}, { "idlab": "", "kind": "" })


                        this.isFullScreenLoading = false
                        return
                       }




                       // if status 5 or 6
                       let fullNameLabNon = "" 
                       if(res.data.lab_kind == 'cyto'){fullNameLabNon = "Cytology"}
                       if(res.data.lab_kind == 'biop'){fullNameLabNon = "Biopsy"}
                       if(res.data.lab_kind == 'necr'){fullNameLabNon = "Necropsy"}
                       if(res.data.lab_kind == 'bact'){fullNameLabNon = "Bacterial"}
                       if(res.data.lab_kind == 'pcr'){fullNameLabNon = "pcr"}
                       if(res.data.lab_kind == 'para'){fullNameLabNon = "Parasite"}
                       if(res.data.lab_kind == 'orga'){fullNameLabNon = "Organism"}



                       this.IDLABSelected = Object.assign({}, { "idlab": res.data.lab_id, "kind": fullNameLabNon})
                    //    console.log('assign IDLABSelected--> ',JSON.stringify(this.IDLABSelected))

                       if( res.data.lab_kind === 'cyto'){
                         this.dataCytoSpecLN =  res.data.lab_detail
                       }

                       if( res.data.lab_kind === 'biop'){
                         this.dataBiopsySpecLN =  res.data.lab_detail
                       }

                       if( res.data.lab_kind === 'necr'){
                         this.dataNecropsySpecLN =  res.data.lab_detail
                       }


                       if( res.data.lab_kind === 'orga'){
                         this.dataORGASpecLN =  res.data.lab_detail
                       }

                       if( res.data.lab_kind === 'pcr'){
                         this.dataPCRSpecLN =  res.data.lab_detail
                       }

                       if( res.data.lab_kind === 'para'){
                         this.dataPARASpecLN =  res.data.lab_detail
                       }

                       if( res.data.lab_kind === 'bact'){
                         this.dataBACTSpecLN =  res.data.lab_detail
                       }


                    //    console.log(JSON.stringify(res.data.lab_detail.data_req ))                        
                       this.infoOPDObj    = Object.assign({}, 
                                                                    {
                                                                    idlab : res.data.lab_id,
                                                                    idopd : res.data.lab_detail.data_req[11].idopd,
                                                                    opdname :  res.data.lab_detail.data_req[12].opdname,
                                                                    type :  `${res.data.lab_detail.data_req[15].speciesname}/${res.data.lab_detail.data_req[14].breedname}`,
                                                                    gender :  res.data.lab_detail.data_req[16].opdgender,
                                                                    age :  res.data.lab_detail.data_req[18].age,
                                                                    owner_name :  res.data.lab_detail.data_req[13].ownername
                                                                    })
                                                                    
                                                                    

                       this.isFullScreenLoading = false
                    })
                    .catch((err)=>{
                             
                            if(err.response.status === 404){
                                    this.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `not found for ${this.LABID_NonAutomate}`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'alert-circle',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true
                                })
                                
                                this.dataCBCSpecLN = null
                                this.dataCytoSpecLN = DATACYTOSPECLN_MODEL
                                this.dataBiopsySpecLN  =  DATABIOPSPECLN_MODEL
                                this.dataPCRSpecLN = DATA_PCR_LN_MODEL
                                this.dataBACTSpecLN = DATA_BACT_LN_MODEL
                                this.dataPARASpecLN = DATA_PARA_LN_MODEL
                                this.dataORGASpecLN = DATA_ORGA_LN_MODEL
                                this.dataNecropsySpecLN = DATANECROPSPECLN_MODEL

                                this.IDLABSelected = Object.assign({}, { "idlab": "", "kind": "" })
                                
                                this.isFullScreenLoading = false
                                return
                            }
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            this.isFullScreenLoading = false
              
                    })
                

            }



        }
    },
    data(){
        return {
            
            isFullScreenLoading : false,
            radioAutomateOrNonAutomate : "0",  // 0 == Automate , 1 == Non Automate
            LABID_Automate : "" ,
            LABID_NonAutomate :"" ,


             
            hasLABID_AutomateError : false,  
            hasLABID_NonAutomateError : false,

            dataCBCSpecLN:null,
            IDLABSelected : { "idlab": "", "kind": "" },



            dataCytoSpecLN : DATACYTOSPECLN_MODEL,
            dataBiopsySpecLN: DATABIOPSPECLN_MODEL,
            dataPCRSpecLN: DATA_PCR_LN_MODEL,
            dataBACTSpecLN: DATA_BACT_LN_MODEL,
            dataPARASpecLN: DATA_PARA_LN_MODEL,
            dataORGASpecLN: DATA_ORGA_LN_MODEL,
            dataNecropsySpecLN: DATANECROPSPECLN_MODEL,


            infoOPDObj : null, 
            // {
            //     idopd : String,
            //     opdname : String,
            //     type : String,
            //     gender : String,
            //     age : String,
            //     owner_name : String,
            // }
        }
    }
}
</script>